import POIStep from "@/components/POI/POIStep/POIStep.vue";
import { uploadFile } from "@/helpers/fileHelper";
import { getMongoFileId, getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import LocationMap from "@/components/Common/LocationMap/LocationMap.vue";
import OptionListDialog from "@/components/Common/OptionListDialog/OptionListDialog.vue";
import {
  checkLat,
  checkLng,
  mapOptionDialogConfig
} from "@/configuration/formConfigurations";
import { OpenStreetMapProvider } from "leaflet-geosearch";
import Vue from "vue";

export default {
  name: "POIRoute",
  props: ["editedItem", "step", "position", "isOwnedBySubPrincipal"],
  components: { POIStep, LocationMap, OptionListDialog },
  data: () => ({
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js",
    tmpFiles: [],
    gpxUpdated: false,
    imagesDragging: false,
    filesDragging: false,
    generatingImage: false,
    locationSearchValue: "",
    editorConfig: {
      height: "150px",
      ...Vue.prototype.$editorConfig
    }
  }),

  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    },
    async addDropFile(e) {
      if (!Array.isArray(this.tmpFiles)) this.tmpFiles = [];
      const files = e?.dataTransfer?.files ?? e ?? [];
      await Array.from(files).asyncForEach(async file => {
        const fileText = await this.readText(file);
        const fileData = await this.readFileUrl(file);
        file.text = fileText;
        file.originalUrl = fileData;
        file.dataUrl = fileData;
        file.title = file.name;
        file.original_name = file.name;
        this.tmpFiles.push(file);
      });
    },
    read(file, returnType = "fileUrl") {
      return new Promise((resolve, reject) => {
        if (file) {
          const reader = new FileReader();
          reader.onload = ({ target }) => {
            if (target?.result) resolve(target.result);
            else reject("Unable to read File");
          };
          if (returnType === "fileUrl") reader.readAsDataURL(file);
          if (returnType === "text") reader.readAsText(file);
        } else reject("No file passed");
      });
    },
    readFileUrl(file) {
      return this.read(file, "fileUrl");
    },
    readText(file) {
      return this.read(file, "text");
    },
    async saveFiles() {
      this.generatingImage = true;
      const files = this.tmpFiles;

      const fileArray = [];
      await files.asyncForEach(async file => {
        if (!file.url) {
          const newFile = await uploadFile(
            file,
            this.editedItem.id || this.editedItem._id,
            "pois",
            this.editedItem.principal,
            progressEvent => {
              this.createSuccess(
                Math.round((progressEvent.loaded * 100) / progressEvent.total) +
                  " % hochgeladen.."
              );
            }
          );
          //add file properties
          file = { ...newFile, ...file };
          delete file.originalUrl;
          delete file.dataUrl;
          file.id = file.id ?? file._id;
          fileArray.push(file);
        } else fileArray.push(file);
      });
      this.tmpFiles = fileArray;
      this.tmpFiles.reverse().reverse();
      if (!this.editedItem?.route) {
        this.editedItem.route = {};
      }

      if (fileArray[0]?.id) {
        //delete old file
        this.$emit(
          "addToDestroyList",
          getMongoFileId(this.editedItem.route.gpx)
        );
        //only one gpx-file (last one)
        this.editedItem.route.gpx = fileArray.slice(-1)[0]; // id + url
        await this.generateGpxImage(this.editedItem.route.gpx.url);
        const parser = new DOMParser();
        const doc = parser.parseFromString(
          this.editedItem.route.gpx.text,
          "application/xml"
        );
        let startTag = doc.querySelector("rtept,trkpt");
        let startGeo = {
          lat: startTag?.getAttribute("lat"),
          lng: startTag?.getAttribute("lon")
        };
        if (!isNaN(startGeo?.lat) && !isNaN(startGeo?.lng)) {
          this.updatePosition(startGeo);
        }
        this.gpxUpdated = true;
      }
      this.generatingImage = false;
    },
    createSuccess(message) {
      this.$emit("success", message);
    },
    createError(error) {
      this.$emit("error", error);
    },
    async generateGpxImage(gpxUrl) {
      try {
        const headers = getTokenHeader();
        const res = await axios.post(
          `${env.poi_api_client_url}gpx-map-image`,
          { url: gpxUrl, width: 250, height: 100 },
          { headers, responseType: "arraybuffer" }
        );

        let blob = new Blob([res.data], { type: "image/png" });
        blob.filename = Date.now() + "_gpx.png";
        const gpxFile = await uploadFile(
          blob,
          this.editedItem.id || this.editedItem._id,
          "pois",
          this.editedItem.principal,
          progressEvent => {
            this.createSuccess(
              Math.round((progressEvent.loaded * 100) / progressEvent.total) +
                " % hochgeladen.."
            );
          }
        );

        if (res.status === 200 || res.status === 201) {
          //delete old image
          if (this.editedItem.route?.image?.id) {
            this.$emit("addToDestroyList", this.editedItem.route.image.id);
          }
          this.editedItem.route.image = gpxFile;
          this.createSuccess("Erfolgreich gespeichert!");
        }
      } catch (err) {
        this.createError(err);
      }
    },
    updatePosition(pos) {
      this.editedItem.geo = pos;
    },
    async searchForLocation(searchValue) {
      const provider = new OpenStreetMapProvider();
      const res = await provider.search({ query: searchValue });
      if (res.length === 1) {
        const { x, y } = res[0];

        this.editedItem.geo = { lng: x, lat: y };
      } else if (res.length) {
        // Ergebnis in das richtige Format bringen
        const options = res.map(r => ({
          lng: r.x,
          lat: r.y,
          displayName: r.label,
          osmId: r.raw.osm_id
        }));
        // tableOptions ist eine Vorgabe wie der Dialog am Ende aussehen soll.
        this.$refs.optionDialog?.showDialog(options, mapOptionDialogConfig);
      } else {
        await this.$store.dispatch("createError", {
          text: "Keine Ergebnisse gefunden"
        });
      }
    },
    checkLng,
    checkLat
  }
};
